import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPurchaseReceipt } from "src/models/Products/PurchaseReceipt.models";

interface PurchaseReceiptState {
    purchaseReceipts: IPurchaseReceipt[];
    purchaseReceiptToEdit: IPurchaseReceipt | null;
}

const initialState: PurchaseReceiptState = {
    purchaseReceipts: [],
    purchaseReceiptToEdit: null,
};

const PurchaseReceiptSlice = createSlice({
    name: "PurchaseReceipt",
    initialState,
    reducers: {
    setPurchaseReceiptList: (
        state,
        action: PayloadAction<IPurchaseReceipt[]>
    ) => {
        state.purchaseReceipts = action.payload;
    },
    concatListPurchaseReceipt: (
        state: PurchaseReceiptState,
        action: PayloadAction<IPurchaseReceipt[]>
    ) => {
        state.purchaseReceipts = [
            ...state.purchaseReceipts.concat(action.payload),
        ];
    },
    setPurchaseReceiptToEdit: (
        state,
        action: PayloadAction<IPurchaseReceipt | null>
    ) => {
        state.purchaseReceiptToEdit = action.payload;
    },
    addPurchaseReceipt: (state, action: PayloadAction<IPurchaseReceipt>) => {
        state.purchaseReceipts.push(action.payload);
    },
    updatePurchaseReceipt: (state, action: PayloadAction<IPurchaseReceipt>) => {
        let itemIndex = state.purchaseReceipts.findIndex(
            item => item.purchaseReceiptId === action.payload.purchaseReceiptId
        );
        if (itemIndex !== -1) state.purchaseReceipts[itemIndex] = action.payload;
    },
    updateOrAddPurchaseReceipts: (state, action: PayloadAction<IPurchaseReceipt[]>) => {
        action.payload.forEach(item => {
            let itemIndex = state.purchaseReceipts.findIndex(
                i => i.purchaseReceiptId === item.purchaseReceiptId
            );
            if (itemIndex !== -1) state.purchaseReceipts[itemIndex] = item;
            else state.purchaseReceipts.push(item);
        });
    },
    deletePurchaseReceipt: (state, action: PayloadAction<number>) => {
        const newArray = state.purchaseReceipts.filter(
            item => item.purchaseReceiptId !== action.payload
        );
        state.purchaseReceipts = newArray;
    },
    },
});

export const {
    setPurchaseReceiptList,
    concatListPurchaseReceipt,
    setPurchaseReceiptToEdit,
    addPurchaseReceipt,
    updatePurchaseReceipt,
    updateOrAddPurchaseReceipts,
    deletePurchaseReceipt,
} = PurchaseReceiptSlice.actions;

export default PurchaseReceiptSlice.reducer;